import React, { Fragment, useState, useEffect, useRef } from 'react';
import { SketchPicker } from "react-color";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { Col, Row } from "react-bootstrap";
import {
    Card,
    CardBody,
    Container
} from "reactstrap";
import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import cx from "classnames";
import CommonHeaderContent from '../../Common/CommonHeaderContent';
import { defaultPrimaryCardStyles } from './Constants';
import CardPanel from './CardPanel';
import { getFormNameandLabel, populateFormDetails, prepareSearchConditionComponent, randstr } from '../../Common/Appcommon';
import SearchPanel from '../Search/SearchPanel';
import { faFloppyDisk } from '@fortawesome/free-solid-svg-icons';
import requestApiService from '../../services/requestApi.service';
import PrimaryConfigForm from './PrimaryConfigForm';
import ComparisonForm from './ComparisonForm';

const ChartConfigModal = (props) => {
    const buttonClickRef = useRef(null);
    let { isModalOpen, closeModal, changeChartStyle, primaryChartType, selectedFolder, primaryChartId, isClone } = props;
    let selectedChartInfo = defaultPrimaryCardStyles[primaryChartType];
    const [formData, setFormData] = useState({});
    const [selectedForm, setSelectedForm] = useState({});
    const [folder, setFolder] = useState(selectedFolder);
    const [selectedMetrics, setSelectedMetrics] = useState({});
    const [formList, setFormList] = useState([]);
    const [formDetail, setFormDetail] = useState([]);
    const [summaryFields, setSummaryFields] = useState([]);
    const [searchComponents, setSearchComponents] = useState({});
    const [sketchPickerColor, setSketchPickerColor] = useState("#FFFFFF");
    const [divStyle, setDivStyle] = useState({});
    const [comparisonData, setComparisonData] = useState("");

    let searchActionCB = false;
    let comparisonSaveActionCB = false;
    let formSaveActionCB = false;
    useEffect(() => {
        (async () => {
            if (primaryChartId !== "") {
                setSearchComponents([]);
                await getPrimaryDashboardDetails();
            } else {
                setSearchComponents([]);
                setSketchPickerColor("#FFFFFF");
                setDivStyle({});
                setFormDetail([]);
            }
            await getFormNameList();

        })();
        return () => {
            // this now gets called when the component unmounts
        };

    }, [primaryChartId]);

    const getPrimaryDashboardDetails = async () => {
        let params = {
            "ENTITY": "DashBoard",
            "OPERATION": "FETCH_NEW_PRIMARY_DB_DETAILS",
            "chartId": primaryChartId,
            "ISREARRAGE": false
        }
        let res = await requestApiService.processServerRequest(params);
        if (res.issuccess) {
            let ddata = res.data;
            if (ddata.length > 0) {
                await preparePrimaryDashboardData(ddata[0]);
            }
        }
    }

    const preparePrimaryDashboardData = async (data) => {
        let dbName = data['db_name'];
        let folderName = data['foldername'];
        let folderId = data['folderid'];
        let formname = data['formname'];
        let dbcolor = data['bgcolor'];
        let summaryby = data['summaryby'];
        let conditionstr = data['data_condition'];
        let chartType = data['chart_type'];
        if (chartType === "comparison") {
            setComparisonData(data['comparison_data']);
        }
        let tmpFormData = {};
        tmpFormData['db_name'] = isClone ? "" : dbName;
        setFolder({ 'value': folderId, 'label': folderName });
        if (dbcolor !== "" && dbcolor !== null) {

            let divStyle = {
                backgroundColor: dbcolor,
                color: "#FFFFFF",
                fontWeight: "bold"
            };
            if (dbcolor.toLowerCase() === "#ffffff") {
                divStyle = {
                    backgroundColor: dbcolor,
                    color: "#000000",
                    fontWeight: "bold"
                };
            }
            setDivStyle(divStyle);
            setSketchPickerColor(dbcolor);
        }
        setFormData(tmpFormData);
        setFormDetail([]);
        let details = await populateFormDetails(formname);
        if (details.length > 0) {
            let scomponents = await prepareSearchConditionComponent(conditionstr, details);
            let fdetail = details[0];
            let formLabel = fdetail[2];
            let form = { 'value': formname, 'label': formLabel };
            await constructSummaryFieldList(details, summaryby);
            setSelectedForm(form);
            setSearchComponents(scomponents);
            setFormDetail(details);
        }

    }

    const getFormNameList = async () => {

        let isEnabledList = {
            "isAddonEnabled": true,
            "isWsappEnabled": false,
            "isProfileEnabled": true,
            "type": "Workflow",
            "isContactRef": false,
            "isMenuEnabledOnly": true,
        };

        let response = await getFormNameandLabel(isEnabledList);
        if (response.issuccess) {
            let data = response.data;
            setFormList(data);
        }
    }

    const saveDashboardConfiguration = () => {
        buttonClickRef.current.click();
    }

    const constructSummaryFieldList = async (details, defaultSummary = "") => {
        let fieldDetails = details[1];
        let summaryList = [];
        summaryList.push({ value: "Record_Count", label: "Record Count" })
        let defaultSum = summaryList[0];
        fieldDetails.map((field, index) => {
            let fieldType = field[4];
            let fieldName = field[2];
            let fieldLabel = field[3];
            if (fieldType === "Currency") {
                let listvalue = { value: fieldName, label: "Sum of " + fieldLabel };
                if (fieldName === defaultSummary) {
                    defaultSum = listvalue;
                }
                summaryList.push(listvalue)
            }
        });
        setSelectedMetrics(defaultSum);
        setSummaryFields(summaryList);
    }

    const searchClickCB = async (callback) => {
        searchActionCB = callback;
    }

    const comparisonSaveClickCB = async (callback) => {
        comparisonSaveActionCB = callback;
    }

    const formSaveClickCB = async (callback) => {
        formSaveActionCB = callback;
    }

    const onFormChange = async (details) => {
        setFormDetail([]);
        setFormDetail(details);
    }

    const submitForm = async () => {
        let isValidSearch = await searchActionCB("validateInput");
        if (!isValidSearch) {
            let searchString = await searchActionCB("getSearchString", {
                modeOfSearch: "AND"
            });
            if (searchString === "") {
                return;
            }
            let saveFormData = await formSaveActionCB();
            if (primaryChartType === "comparison") {
                let comparisonData = await comparisonSaveActionCB();
                saveFormData['comparison_data'] = comparisonData;
            }
            //let saveFormData = {};
            //saveFormData = formData;
            saveFormData['folder'] = selectedFolder;
            saveFormData['searchString'] = searchString;
            //saveFormData['form'] = selectedForm;
            //saveFormData['metric'] = selectedMetrics;
            saveFormData['chartType'] = primaryChartType;
            saveFormData['color'] = sketchPickerColor;
            let key = randstr("pri_") + "##";
            saveFormData['layoutkey'] = key;
            let params = {
                "ENTITY": "DashBoard",
                "OPERATION": primaryChartId === "" || isClone ? "NEW_DASHBOARD_SAVE" : "NEW_DASHBOARD_UPDATE",
                "DATA": saveFormData,
                "chartId": isClone ? "" : primaryChartId,
            }
            let res = await requestApiService.processServerRequest(params);
            if (res.issuccess) {
                onCloseCurrentModal(null, true);
            }
        }
    }

    const onCloseCurrentModal = (e, isRefresh = false) => {
        setFormData({});
        setSelectedForm({});
        setSelectedMetrics({});
        closeModal(isRefresh);
    }

    const onInputChange = async (e) => {
        let name = e.target.name;
        let value = e.target.value;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value
        }));
    }

    const { register, handleSubmit: handleActionFormSubmit, control, formState: { errors }, getValues } = useForm();
    return (
        <Modal isOpen={isModalOpen} className={"config-chart-modal le-modal-lg campaign-modal"}>
            <ModalBody>
                <Fragment>
                    <CommonHeaderContent
                        isModal={true}
                        closeModal={onCloseCurrentModal}
                        buttonTxt={"Save"}
                        buttonAction={saveDashboardConfiguration}
                        buttonIcon={faFloppyDisk}
                        buttonOutline={'success'}
                        headerTitle={"Growth Index KPI"}
                        isClassNeeded={false}
                        mainContent={
                            <div className='pd-config-container'>
                                <div className='d-flex-alone'>
                                    <Row>
                                        <Col md="4" className='pd-panel-preview text-center'>
                                            {
                                                selectedChartInfo !== undefined &&
                                                <CardPanel
                                                    name={selectedChartInfo.name}
                                                    sumvalue={selectedChartInfo.sumvalue}
                                                    countvalue={selectedChartInfo.countvalue}
                                                    md="12"
                                                    primaryChartType=""
                                                    disabled={true}
                                                    divStyle={divStyle}
                                                />
                                            }
                                            <a className="cursor-pointer change-style-btn" onClick={(e) => { changeChartStyle(primaryChartType) }}>Change Style</a>
                                            <Col className={cx('mt-2', { "hide": primaryChartType === "comparison" })} md="12">
                                                <SketchPicker
                                                    onChange={(color) => {
                                                        if (color.hex !== "" && color.hex.toLowerCase() !== "#ffffff") {
                                                            let divStyle = {
                                                                backgroundColor: color.hex,
                                                                color: "#FFFFFF",
                                                                fontWeight: "bold"
                                                            };
                                                            setDivStyle(divStyle);
                                                        }
                                                        setSketchPickerColor(color.hex);
                                                    }}
                                                    color={sketchPickerColor}
                                                />
                                            </Col>

                                        </Col>
                                        <Col md="8" className='pd-panel-config'>
                                            <div className='config-container'>
                                                <span className='config-title f18'>
                                                    Component
                                                </span>
                                                <div className='dashboard-section mt-3'>
                                                    <form id="config-form" name="primary-db" onSubmit={handleActionFormSubmit(submitForm)}>
                                                        <div className='form-conatiner'>
                                                            {<PrimaryConfigForm
                                                                key={"config-form-"}
                                                                control={control}
                                                                errors={errors}
                                                                preFormData={formData}
                                                                preFormDetail={formDetail}
                                                                preFormList={formList}
                                                                preSelectedForm={selectedForm}
                                                                preSelectedSummary={selectedMetrics}
                                                                preSummaryList={summaryFields}
                                                                onSearchClickRegister={formSaveClickCB}
                                                                onFormChange={onFormChange}
                                                                chartType={primaryChartType}
                                                            />}
                                                            {formDetail.length > 0 && <div className={cx('input-section mt-3')}>
                                                                <label className={'workflow-lbl d-flex-alone form-label'} htmlFor="condition">Criteria Filter</label>
                                                                <SearchPanel
                                                                    key={"search-panel-config"}
                                                                    fieldDetails={formDetail[1]}
                                                                    onSearchClickRegister={searchClickCB}
                                                                    preSearchComponents={searchComponents}
                                                                    forceFilter={true}
                                                                    filterType={"trigger"}
                                                                    searchStringType={"form"}
                                                                    actionType={"user"}
                                                                />
                                                            </div>
                                                            }
                                                            {primaryChartType === "comparison" && <ComparisonForm
                                                                key={"config-form-"}
                                                                control={control}
                                                                errors={errors}
                                                                preFormDetail={formDetail}
                                                                onSearchClickRegister={comparisonSaveClickCB}
                                                                chartType={primaryChartType}
                                                                data={comparisonData}
                                                            />}
                                                            <div>
                                                                <span className="hide">
                                                                    <button ref={buttonClickRef} type="submit">
                                                                        <span>Save</span>
                                                                    </button>
                                                                </span>
                                                            </div>

                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </div>
                        } />
                </Fragment>
            </ModalBody>
        </Modal>
    )
}

export default ChartConfigModal;